import React, { useState, useEffect } from 'react'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'
import './footer.css'
import { Button, Drawer, Tooltip } from '@material-ui/core'
import { useLocation } from 'react-router-dom'
import InstagramIcon from '@material-ui/icons/Instagram'
import Swal from 'sweetalert2'
import jsonp from 'jsonp'
import queryString from 'query-string'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import { useTranslation } from 'react-i18next'
const Footer = () => {
    let getLoginUser = JSON.parse(localStorage.getItem('coachUser'))
    const location = useLocation()
    const { t, i18n } = useTranslation()
    const [user, setUser] = React.useState(
        localStorage.getItem('coachUser') ? JSON.parse(localStorage.getItem('coachUser')) : {},
    )

    useEffect(() => {
        setUser(JSON.parse(localStorage.getItem('coachUser')))
    }, [localStorage.getItem('coachUser')])

    const currentLanguage = i18n.language
    const homePageTop = () => {
        window.scrollTo({ top: 0, right: 0, behavior: 'smooth' })
    }
    const [state, setState] = useState({
        bottom: false,
    })
    const [inpData, setinpData] = useState('')
    const subscribe = () => {
        if (inpData) {
            if (!/\S+@\S+\.\S+/.test(inpData)) {
                return Swal.fire({
                    title: 'Please enter a valid email!',
                    icon: 'error',
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 1500,
                })
            }

            const data = {
                EMAIL: inpData,
            }

            jsonp(
                `//coachandgavel.us6.list-manage.com/subscribe/post-json?u=ac688580f769829bc4155538a&id=88f833db23&${queryString.stringify(
                    data,
                )}`,
                { param: 'c' },
                (err, data) => {
                    //console.log('display', data.result)
                    if (err) {
                        return console.log('display', err)
                    }
                    if (data.result === 'success') {
                        setinpData('')
                        return Swal.fire({
                            title: data.msg,
                            icon: 'success',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: 1500,
                        })
                    }
                    if (data.result === 'error') {
                        return Swal.fire({
                            title: data.msg.split('<')[0],
                            icon: 'warning',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: 1500,
                        })
                    }
                },
            )
        }
        setinpData('')
    }

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return
        }

        setState({ ...state, [anchor]: open })
    }

    return (
        <div className="footer">
            <div className="customContainer">
                {location.pathname.includes('/') && (
                    <>
                        <Button className="getEstimateBtn" onClick={toggleDrawer('bottom', true)}>
                            <small>
                                Need a <br /> shipping quote?
                            </small>
                            <img src="/assets/images/uship2.PNG" />
                        </Button>

                        <Drawer
                            anchor={'bottom'}
                            open={state['bottom']}
                            onClose={toggleDrawer('bottom', false)}
                            className="getEstimateDrawer"
                        >
                            <div style={{ fontFamily: 'arial', textAlign: 'center' }}>
                                <iframe
                                    frameBorder="0"
                                    target="_self"
                                    src="https://www.uship.com/widget/widget_quote.aspx?widgetstyle=vertical&amp;color=yellow&amp;category=4&amp;subcategory=79&amp;z1=&amp;z2=&amp;country2=US&amp;country1=US&amp;referid=8641787&amp;embedurl=file%3A///D%3A/widget.html&amp;widgettype=quote_widget_1_0&amp;siteid=1&amp;showemailaddress=false&amp;defaultweight=false"
                                    height="410"
                                    width="225"
                                    scrolling="no"
                                ></iframe>
                            </div>
                        </Drawer>
                    </>
                )}
                <div className="footer-content"></div>
                <div className="footerContainer">
                    <div className="row text-left">
                        <div className="col-md-2">
                            <Link
                                to={
                                    user?.role == 0
                                        ? '/home'
                                        : user?.role == 1
                                        ? '/'
                                        : user?.role == 4
                                        ? '/dashboard/ambassador/mylots'
                                        : '/'
                                }
                            >
                                <div className="footer-logo">
                                    <img
                                        src={
                                            currentLanguage == 'for_english'
                                                ? '/assets/svg/Carzaar-Logo_footer_en.svg'
                                                : '/assets/svg/Carzaar-Logo_footer_swe.svg'
                                        }
                                        alt="footerLogo"
                                        className="footer-logo-img"
                                    />
                                </div>
                            </Link>
                        </div>

                        <div className="col-md-2">
                            <h3 className="h6">{t('about')}</h3>
                            <ul className="list-unstyled">
                                <li>
                                    <Link to="/about_us" className="text-white">
                                        {t('about_us')}
                                    </Link>
                                </li>
                            </ul>
                        </div>

                        <div className="col-md-2">
                            <h3 className="h6">{t('help_center')}</h3>
                            <ul className="list-unstyled">
                                <li>
                                    <Link to="/faq" className="fw-bold text-white">
                                        {t('faq')}
                                    </Link>
                                </li>

                                <li>
                                    <Link to="/terms" className="fw-bold text-white">
                                        {t('terms_condtion_text')}
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/smooth_selling_process"
                                        className="fw-bold text-white"
                                    >
                                        {t('smooth_selling_process')}
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-2">
                            <h3 className="h6"> {t('contact_us')}</h3>
                            <ul className="list-unstyled">
                                <li>
                                    {t('email')}:{' '}
                                    <a
                                        href="mailto:info@carzaar.se"
                                        style={{ textDecoration: 'none' }}
                                    >
                                        info@carzaar.se
                                    </a>
                                </li>

                                <li>
                                    {t('phone_text')}:{' '}
                                    <a href="tel:+46703666131" style={{ textDecoration: 'none' }}>
                                        +46 703 666 131
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="border-top border-secondary mt-4 pt-3 text-center">
                    <div
                        className="d-flex justify-content-between flex-wrap"
                        style={{ gap: '15px' }}
                    >
                        <p className="text-white">{t('copyright')}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer
